// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"b45eae50","68":"30f9f80c","141":"7d418d04","193":"96fb7df8","246":"a6df2768","275":"937a0f42","368":"ed34949b","395":"82548bf7","636":"6091fdd1","863":"9f9223f2","896":"a4c49923","976":"59e73fc2","986":"9119135d"}[chunkId] + ".chunk.js";
};